export default __webpack_public_path__ + "static/media/volkswagen.89e4e1ad.svg";